module.exports = __webpack_public_path__ + "static/img/hua.143c01c3.png";